/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserMessageRequest
 */
export interface UserMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof UserMessageRequest
     */
    message?: string;
}

/**
 * Check if a given object implements the UserMessageRequest interface.
 */
export function instanceOfUserMessageRequest(value: object): value is UserMessageRequest {
    return true;
}

export function UserMessageRequestFromJSON(json: any): UserMessageRequest {
    return UserMessageRequestFromJSONTyped(json, false);
}

export function UserMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMessageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function UserMessageRequestToJSON(json: any): UserMessageRequest {
    return UserMessageRequestToJSONTyped(json, false);
}

export function UserMessageRequestToJSONTyped(value?: UserMessageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

